import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const VoicesPromo = () => {
	const block = document.querySelectorAll(".voices-promo");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);
	let mm = gsap.matchMedia();

	block.forEach((element) => {
		const audio = element.querySelector("audio");
		const control = element.querySelector(".voices-promo__control");
		const image = element.querySelector(".voices-promo__image");

		const pauseAudio = () => {
			audio.pause();
			element.classList.remove("playing");
		};

		const playAudio = () => {
			audio.play();
			element.classList.add("playing");
		};

		// set pause if not in viewbox
		gsap.timeline({
			scrollTrigger: {
				trigger: element,
				start: "top bottom",
				scrub: true,
				onLeave: () => {
					pauseAudio();
				},
				onLeaveBack: () => {
					pauseAudio();
				}
			}
		});

		const toggleSound = () => {
			if (element.classList.contains("playing")) {
				pauseAudio();
			} else {
				playAudio();
			}
		};

		mm.add("(max-width: 1023px)", () => {
			control.addEventListener("click", (e) => {
				toggleSound();
			});
		});

		mm.add("(min-width: 1024px)", () => {
			const moveCursor = function (event) {
				gsap.to(control, {
					css: {
						left: event.offsetX,
						top: event.offsetY
					},
					duration: 0.4
				});
			};

			image.addEventListener("mouseover", (e) => {
				document.addEventListener("mousemove", moveCursor, false);
			});

			image.addEventListener("mouseleave", (e) => {
				document.removeEventListener("mousemove", moveCursor, false);
				gsap.to(control, { css: { left: "50%", top: "50%" }, duration: 0.5 });
			});

			image.addEventListener("click", (e) => {
				toggleSound();
			});
		});
	});
};

export default VoicesPromo;
